// Le dictionnaire de référence : les autres langues seront typées contre ses clés
// (`Record<I18nKey, string>`), si bien qu'une clé oubliée sera une erreur de compilation.
export const fr = {
  'level.1': 'débutant',
  'level.2': 'facile',
  'level.3': 'intermédiaire',
  'level.4': 'complexe',

  'bar.close': 'Fermer et revenir au chemin',
  'bar.chapter': 'Chapitre {n} · {title}',
  'bar.stars': '{n} étoiles dans ce chapitre',

  'daily.title': 'Mot du jour',
  'daily.sub': 'le même pour tous, aujourd’hui',
  'daily.streak': '{n} j.',
  'daily.streakAria': 'Série de {n} jour(s)',
  'settings.rate': 'Noter Verbigrid',
  'settings.rateHint': 'Un avis sur le Play Store aide le jeu à se faire connaître',
  'daily.offline': 'Le mot du jour demande une connexion. Réessaie quand tu auras du réseau.',
  'daily.none': 'Pas de mot du jour pour l’instant : reviens demain.',
  'daily.bar': 'Mot du jour',

  'chap.prev': 'Chapitre précédent',
  'chap.next': 'Chapitre suivant',
  'chap.num': 'CHAPITRE {n}',
  'chap.done': 'terminé · {stars} / {max}',
  'chap.locked': 'verrouillé',
  'chap.progress': '{done} / {total}',
  'chap.waiting': '{n} à reprendre',
  'chap.toUnlock': 'encore {n} pour la suite',
  'chap.unlocked': 'suite ouverte',

  'node.done': 'Partie {n}, finie, {stars} étoile(s)',
  'node.skipped': 'Partie {n}, passée, à reprendre',
  'node.current': 'Partie {n}, la prochaine',
  'node.locked': 'Partie {n}, pas encore ouverte',
  'node.here': 'à toi !',

  'sheet.part': 'Partie {n}',
  'sheet.last': 'Partie {n} · la dernière',
  'sheet.meta': '{rows} mots · {level}',
  'sheet.skipped': 'Passée · elle t’attend, reprends-la quand tu veux',
  'sheet.locked': 'Pas encore ouverte · {rows} mots',
  'sheet.done': '{stars} étoile(s) sur 3 · {rows} mots',
  'sheet.chapterLocked':
    'Ce chapitre s’ouvre à {need} parties finies du précédent (encore {left}).',
  'sheet.play': 'Jouer',
  'sheet.resume': 'Reprendre',
  'sheet.replay': 'Rejouer',
  'sheet.soon': 'Bientôt',
  'sheet.skip': 'Passer',
  'sheet.passes': '{n} sur {max}',

  'play.level': '{chapter} · partie {n}',
  'play.lane': 'Choisir le mot : {clues}',
  'play.cell': 'Ligne {r}, lettre {c}',
  'play.mystery': 'mot mystère',
  'play.hint': 'Indice {n}',
  'play.noHint': 'Plus d’indice',
  'play.ad': 'PUB',
  'play.reveal': 'Révéler',
  'play.dir': 'sens',
  'play.dirAria': 'Passer de la ligne au mot mystère',
  'play.erase': 'Effacer',
  'play.keyboard': 'Clavier du jeu',
  'play.found': '{word} !',
  'play.wrong': 'Pas tout à fait…',
  'play.mysteryFound': 'Mot mystère trouvé !',
  'play.mysteryHelp': 'Le mot mystère n’a pas d’indice : il se devine avec les lettres des lignes.',
  'play.loading': 'Chargement de la partie…',
  'play.offline': 'Cette partie n’est pas encore sur l’appareil, et le serveur ne répond pas.',

  'end.title': 'Trouvé !',
  'end.stars3': 'Sans aucun indice : trois étoiles !',
  'end.stars2': 'Avec un indice : deux étoiles',
  'end.stars1': 'Trouvé, avec un coup de pouce',
  'end.expr': 'LE MOT EN EXPRESSIONS',
  'end.words': 'LES MOTS DE LA PARTIE',
  'end.collection': 'La collection « {title} »',
  'end.unlock': 'Encore {n} partie(s) pour ouvrir la suite.',
  'end.opened': 'Chapitre « {title} » ouvert !',
  'end.complete': 'Chapitre terminé, bravo.',
  'end.path': 'Le chemin',
  'end.next': 'Partie suivante',
  'end.daily': 'Mot du jour trouvé · série de {n} jour(s)',

  'state.loading': 'Chargement…',
  'state.offline': 'Impossible de joindre le serveur. Vérifie ta connexion.',
  'state.empty': 'Aucun chapitre publié pour l’instant.',
  'state.retry': 'Réessayer',
  'state.newer':
    'Une nouvelle version de l’application apporte du contenu : pense à la mettre à jour.',

  'coach.ribbon':
    'Chaque mot à trouver donne une lettre au ruban violet : mises bout à bout, elles forment le mot mystère.',
  'coach.type': 'Touche un couloir, puis tape le mot avec le clavier du jeu.',
  'coach.hint':
    'Bloqué ? « Indice » ajoute un mot plus parlant, et « Révéler » donne toute la ligne.',
  'coach.mystery':
    'Tu devines déjà le mot mystère ? Touche deux fois une case violette, ou « sens », pour l’écrire directement.',
  'coach.ok': 'Compris',

  'account.open': 'Ma progression',
  'account.title': 'Ta progression',
  'account.intro':
    'Tes parties et tes étoiles sont gardées sur cet appareil et en ligne. Note ton code de reprise : sur un autre téléphone, il les retrouve.',
  'account.codeLabel': 'Ton code de reprise',
  'account.loading': 'Un instant…',
  'account.offline': 'Hors ligne : ton code s’affichera au retour du réseau.',
  'account.copy': 'Copier',
  'account.copied': 'Copié !',
  'account.restoreTitle': 'Reprendre une progression',
  'account.restoreText':
    'Tu as noté un code sur un autre appareil ? Entre-le ici : sa progression arrive, et celle de cet appareil s’y ajoute. Rien n’est perdu.',
  'account.placeholder': 'ex. : oak-moon-river-cat-bell',
  'account.restore': 'Reprendre',
  'account.restoring': 'Un instant…',
  'account.unknown': 'Ce code ne correspond à aucune progression. Vérifie-le mot par mot.',
  'account.busy': 'Trop d’essais d’un coup : réessaie dans une minute.',
  'account.failed': 'Le serveur ne répond pas. Réessaie un peu plus tard.',
  'account.same': 'C’est déjà le code de cet appareil.',
  'account.done': 'Progression retrouvée ! Ton chemin est à jour.',
  'account.close': 'Fermer',

  'settings.open': 'Réglages',
  'settings.title': 'Réglages',
  'settings.back': 'Revenir au chemin',
  'settings.game': 'Le jeu',
  'settings.haptics': 'Vibrations',
  'settings.hapticsHint': 'Une petite secousse quand un mot est trouvé',
  'settings.motion': 'Animations',
  'settings.motionHint': 'Confettis, décors qui bougent, tuiles qui sautent',
  'settings.keyboard': 'Clavier',
  'settings.keyboardHint': 'L’ordre des lettres du clavier du jeu',
  'settings.coach': 'Revoir les bulles d’aide',
  'settings.coachHint': 'Elles reviendront sur les prochaines parties',
  'settings.coachDone': 'Les bulles d’aide reviendront à la prochaine partie.',
  'settings.save': 'Ta sauvegarde',
  'settings.recovery': 'Retrouver ma progression',
  'settings.recoveryHint': 'Un code à garder, pour reprendre sur un autre téléphone',
  'settings.wipe': 'Supprimer mes données',
  'settings.wipeHint': 'Le compte et toute la progression, ici et sur le serveur',
  'settings.wipeConfirm': 'Supprimer le compte et toute la progression ? C’est définitif.',
  'settings.wipeFailed': 'Le serveur ne répond pas : rien n’a été supprimé. Réessaie connecté.',
  'settings.about': 'À propos',
  'settings.version': 'Version {v}',
  'settings.tagline': 'Le mot mystère, une lettre à la fois',

  'install.title': 'Verbigrid existe en application',
  'install.short': 'Hors ligne, en plein écran, et ta progression te suit.',
  'install.cta': 'Installer',
  'install.close': 'Plus tard',
  'install.cardTitle': 'Continue dans l’application',
  'install.why1': 'Une icône sur ton écran d’accueil, le mot du jour à portée de pouce',
  'install.why2': 'Joue sans réseau, dans le métro comme en avion',
  'install.why3': 'Ta progression te suit : ton code de reprise est dans Réglages',

  'share.cta': 'Partager',
  'share.copied': 'Résultat copié : colle-le où tu veux.',
  'share.daily': 'mot du jour du {date}',
  'share.part': '{chapter}, partie {n}',

  'update.text': 'Une nouvelle version de Verbigrid est prête.',
  'update.now': 'Mettre à jour',
  'update.reloading': 'Mise à jour…',
} as const;

export type I18nKey = keyof typeof fr;
